// GENERATED from tokens.json; do not hand-edit.
export const motionTokens = {
  "duration": {
    "instant": 0.12,
    "fast": 0.16,
    "exit": 0.18,
    "standard": 0.24,
    "considered": 0.48,
    "spinner": 0.7,
    "themeReveal": 0.6
  },
  "ease": {
    "enter": [
      0.16,
      1,
      0.3,
      1
    ],
    "exit": [
      0.7,
      0,
      0.84,
      0
    ],
    "standard": [
      0.22,
      1,
      0.36,
      1
    ],
    "inOut": [
      0.65,
      0,
      0.35,
      1
    ],
    "themeReveal": [
      0.22,
      1,
      0.36,
      1
    ]
  },
  "spring": {
    "snappy": {
      "type": "spring",
      "visualDuration": 0.26,
      "bounce": 0.12
    },
    "morph": {
      "type": "spring",
      "visualDuration": 0.42,
      "bounce": 0.16
    },
    "smooth": {
      "type": "spring",
      "visualDuration": 0.4,
      "bounce": 0
    },
    "responsive": {
      "type": "spring",
      "stiffness": 520,
      "damping": 38
    },
    "gentle": {
      "type": "spring",
      "stiffness": 340,
      "damping": 34
    }
  },
  "blur": {
    "subtle": 2,
    "soft": 4,
    "text": 8
  },
  "button": {
    "pressWide": 0.985,
    "pressIcon": 0.96,
    "press": 0.97,
    "wideThreshold": 220,
    "iconThreshold": 48,
    "textEnterY": 4,
    "textExitY": -3,
    "iconScale": 0.6,
    "loaderExitScale": 0.8,
    "morphWindowMs": 700
  },
  "stagger": {
    "char": 0.016,
    "word": 0.04,
    "line": 0.08,
    "item": 0.035
  }
} as const;
